if (!customElements.get('product-canvas')) {

  const ProductViewType = {
    View1: 1,
    View2: 2,
    View3: 3
  }
  class DataRenderToCanvas {
    partName;
    variantName
    imgView1;
    imgView2;
    imgView3;
    order;
    partShopifyID;
    constructor(partName, variantName, imgView1, imgView2, imgView3, order, partShopifyID) {
      this.partName = partName;
      this.variantName = variantName;
      this.imgView1 = imgView1;
      this.imgView2 = imgView2;
      this.imgView3 = imgView3;
      this.order = order;
      this.partShopifyID = partShopifyID;
    }
  }
  class ProductDisplay extends HTMLElement {

    timeAnimation = 200;
    dataRender = {};
    width = 600;
    height = 400;

    canvasWidth = 1000;
    canvasHeight = 1000 / 1.5;
    viewtype = ProductViewType.View2;
    productPageManager;

    layerRender;
    constructor() {
      super();

      this.productPageManager = document.getElementById("product-page-content");


      this.width = 500
      var w = Math.min(window.innerWidth, window.screen.width);
      var h = window.innerHeight;
      if (w <= 600) {
        this.width = w * 0.8;
        this.width = Math.min(this.width, 300)
        this.height = this.width / 1.5;
      }
      else if (w <= 1200) {
        this.width = w * 0.5;
        this.width = Math.min(this.width, 600)
        this.height = this.width / 1.5;
      } else {
        this.width = w * 0.5;
        this.width = Math.min(this.width, 600)
        this.height = this.width / 1.5;
      }
      this.initHoverToZoom();

      // product-part-value
      const urlParams = new URLSearchParams(window.location.search);
      var view = urlParams.get('view') || this.productPageManager.dataset.first_view;

      if (view != undefined) {
        if (typeof view == "string") {
          view = parseInt(view);
        } else if (typeof view != "number") {
          view = this.productPageManager.dataset.first_view;
        }
        if (view > 3) view = this.productPageManager.dataset.first_view;
      }
      this.viewtype = view;

      this.listentEventPartValueChanged()
      var viewControl = document.getElementsByTagName("product-custom-view").item(0);
      viewControl.setView(this.viewtype)
      // console.log(viewControl);
      this.initImageCompareCss();

    }

    updateCanvasSize() {
      this.width = 500
      var w = Math.min(window.innerWidth, window.screen.width);
      var h = window.innerHeight;
      if (w <= 600) {
        this.width = w * 0.8;
        this.width = Math.min(this.width, 300)
        this.height = this.width / 1.5;
      }
      else if (w <= 1200) {
        this.width = w * 0.5;
        this.width = Math.min(this.width, 600)
        this.height = this.width / 1.5;
      } else {
        this.width = w * 0.5;
        this.width = Math.min(this.width, 600)
        this.height = this.width / 1.5;
      }

      this.stage.content.style.width = this.width + "px";
      this.stage.content.style.height = this.height + "px";


      this.layerRender.canvas._canvas.style.width = this.width + "px";
      this.layerRender.canvas._canvas.style.height = this.height + "px";
    }

    initImageCompareCss() {
      var style = document.createElement('style')
      style.innerHTML = '::slotted(img) { height: auto;}'
      document.querySelector("image-compare").shadowRoot.appendChild(style)
    }

    setPartValue(part, partvalue, view1, view2, view3, _order, partShopifyID) {
      this.setPart(part, partvalue, view1, view2, view3, _order, partShopifyID);
      this.startLoad()
      this.updateURLAndUpdatePrice();
    }

    listentEventPartValueChanged() {

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productPartChange, (event) => {
        const { part, partvalue, view1, view2, view3, order, partShopifyId } = event.data;
        // console.log(event.data);
        let _order = parseInt(order || "0");
        this.setPart(part, partvalue, view1, view2, view3, _order, partShopifyId);
        this.startLoad()
        this.updateURLAndUpdatePrice();
        this.updateCompareLens(event);

      });
      this.viewChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productViewChange, (event) => {
        this.viewtype = event.data;
        this.startLoad();
        this.updateURLAndUpdatePrice();


      });

    }
    updateCompareLens(data) {
      $('product-canvas').css('display', 'block');
      $('.product-media-info-container image-compare').css('display', 'none');
    }
    removeListennerEvents() {
      this.variantChangeUnsubscriber();
      this.viewChangeUnsubscriber();
    }

    evtOnResize = this.updateCanvasSize.bind(this)
    connectedCallback() {
      window.addEventListener("resize", this.evtOnResize)
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.evtOnResize)

      this.removeListennerEvents();
    }
    showFeaturedImage() {

      const imgEl = new Image();;
      imgEl.src = this.dataset.featured_image;

      imgEl.onload = () => {
        var backgroundImage = new Konva.Image({
          width: this.canvasWidth,
          height: this.canvasHeight,
          x: 0,
          y: 0,
          image: imgEl
        });
        // console.log(this.layerRender);
        this.layerRender.add(backgroundImage);
      };



    }
    initHoverToZoom() {

      var divContainer = document.getElementById("product-media-container");
      divContainer.id = "product-media-container"
      // this.prepend(divContainer);
      // divContainer.style.width = "100%";
      // divContainer.style.aspectRatio = "1.5";
      var stage = new Konva.Stage({
        container: 'product-media-container',
        width: this.canvasWidth,
        height: this.canvasHeight,
        preventDefault: false,

      });
      this.stage = stage;

      var layer = new Konva.Layer({ preventDefault: false });
      this.layerRender = layer;
      this.canvas = this.layerRender.canvas._canvas;
      stage.add(layer);


      stage.content.style.width = this.width + "px";
      stage.content.style.height = this.height + "px";
      stage.content.style.margin = "auto";

      layer.canvas._canvas.style.cursor = "zoom-in";
      layer.canvas._canvas.style.width = this.width + "px";
      layer.canvas._canvas.style.height = this.height + "px";

      const ctx = layer.canvas._canvas.getContext("2d");
      // console.log(ctx);
      ctx.imageSmoothingEnabled = true;


      var zoomLevel = 1.5;
      layer.on('mouseenter', function () {
        console.log(window.screen.width);
        if (window.screen.width >= 768) {
          layer.scale({
            x: zoomLevel,
            y: zoomLevel,
          });
          layer.canvas._canvas.style.transform = "scale(1.2)";
        }

      });

      layer.on('mousemove', function (e) {
        if (window.screen.width >= 768) {
          var pos = stage.getPointerPosition();
          layer.x(-pos.x);
          layer.y(-pos.y);
        }

      });
      this.canvas.addEventListener("mouseleave", () => {
        if (window.screen.width >= 768) {
          layer.x(0);
          layer.y(0);
          layer.scale({
            x: 1,
            y: 1,
          });
          layer.canvas._canvas.style.transform = "scale(1)";
        }
      })
      // layer.on('mouseleave', function () {
      //   layer.x(0);
      //   layer.y(0);
      //   layer.scale({
      //     x: 1,
      //     y: 1,
      //   });
      // });
    }

    updateURLAndUpdatePrice() {
      if (this.dataset.updateUrl === 'false') return;
      // console.log("updateURLAndUpdatePrice", this.getProductURL());
      window.history.replaceState({}, '', this.getProductURL());
      this.updatePrice();

    }
    updatePrice() {
      this.productPageManager.updatePrice(this.dataRender);
    }

    timmerAnim;
    loadID;
    startLoad() {
      this.loadID = this.loadImageToCanvas(this.getSourceToRender(), this.onImagesLoaded.bind(this));
      this.updateImagesHeader(this.getSourceToRenderHeader())
    }
    updateImagesHeader(sources) {

      var mainProductHeader = document.getElementsByTagName("main-product-header").item(0);
      if (mainProductHeader) {
        if (typeof mainProductHeader.changeProductImgs == "function") {
          mainProductHeader.changeProductImgs(sources)
        } else {
          mainProductHeader.dataset.imgs = JSON.stringify(sources)
        }
      }
    }



    onImagesLoaded(images, id) {
      if (this.loadID != id) {
        return;
      }
      this.imagesNeedDraw = images;

      this.clearCanvas();
      this.imagesNeedDraw.forEach(img => {


        var backgroundImage = new Konva.Image({
          width: this.canvasWidth,
          height: this.canvasHeight,
          x: 0,
          y: 0,
          image: img,
          preventDefault: false
        });
        this.layerRender.add(backgroundImage);

      });


      // this.context.imageSmoothingEnabled = true;
      // this.imagesNeedDraw = images;
      // if (this.isLoading == false) {
      //   this.imagesNeedDraw.forEach(img => {
      //     this.context.drawImage(img, 0, 0, this.width, this.height, 0, 0, this.width, this.height);
      //   });
      // }

    }

    clearCanvas() {
      this.layerRender.destroyChildren();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      // console.log(
      //   `Attribute ${name} has changed from ${oldValue} to ${newValue}.`,
      // );
    }

    isLoading = false;
    imagesNeedDraw;
    loadImageToCanvas(sources, callback) {

      //console.log("loadImageToCanvas", sources);


      var images = [];
      this.imagesNeedDraw = [];
      var loadedImages = 0;
      var numImages = sources.length;
      this.isLoading = true;
      var id = sources.join("_");
      for (let index = 0; index < sources.length; index++) {
        const src = sources[index];
        const imgEl = new Image();;
        images.push(imgEl)

        imgEl.onload = () => {
          if (++loadedImages >= numImages) {
            this.isLoading = false;

            callback(images, id);
          }
        };
        let _src = src || '';
        if (src.indexOf("//") == 0) _src = "https:" + src;
        else _src = src
        imgEl.src = _src;


      }
      return id
    }
    setPart(partName, partvalue, imgView1, imgView2, imgView3, order, partShopifyID) {
      this.dataRender[partName] = new DataRenderToCanvas(partName, partvalue, imgView1, imgView2, imgView3, order, partShopifyID)
    }

    getProductURL() {
      window.product_variant_selected = undefined;

      window.product_option_selected = [];
      var url = this.dataset.url;
      url += `?view=${this.viewtype}`
      var parts = [];
      var keys = Object.keys(this.dataRender || {});
      for (let index = 0; index < keys.length; index++) {
        const element = this.dataRender[keys[index]];
        // url += `&${keys[index]}=${element.variantName}`r
        window.product_option_selected.push(element)
        parts.push(element.variantName)
      }

      url += "&parts=" + parts.join(",")

      var variantSelected = this.productPageManager.getVariant(this.dataRender);
      // console.log("updateURLAndUpdatePrice", variantSelected);

      if (variantSelected) {
        window.product_variant_selected = variantSelected.id;
        url += `&variant=${variantSelected.id}`
      }
      return url;
    }

    getSourceToRenderHeader() {
      var images = [];
      var keys = Object.keys(this.dataRender || {});
      for (let index = 0; index < keys.length; index++) {
        //console.log(this.dataRender[keys[index]], 'this.dataRender[keys[index]]')
        var imgView;
        switch (this.viewtype) {
          case ProductViewType.View1:
            imgView = this.dataRender[keys[index]].imgView1;
            break;
          case ProductViewType.View2:
            imgView = this.dataRender[keys[index]].imgView2;
            break;
          case ProductViewType.View3:
            imgView = this.dataRender[keys[index]].imgView3;
            break;
          default:
            break;
        }
        // const imgView = this.dataRender[keys[index]].imgView2;
        var _src = imgView;
        if (imgView) {
          if (imgView.indexOf("//") == 0) _src = "https:" + imgView;

          images.push({ order: this.dataRender[keys[index]].order, src: _src })
        }
      }
      images.sort(function (a, b) { return a.order - b.order });
      return images.filter(el => el.src != undefined).map(el => el.src);
    }

    getSourceToRender() {
      var images = [];
      var keys = Object.keys(this.dataRender || {});
      for (let index = 0; index < keys.length; index++) {
        const element = this.dataRender[keys[index]];
        switch (this.viewtype) {
          case ProductViewType.View1:
            images.push({ order: element.order, src: element.imgView1 })
            break;
          case ProductViewType.View2:
            images.push({ order: element.order, src: element.imgView2 })
            break;
          case ProductViewType.View3:
            images.push({ order: element.order, src: element.imgView3 })
            break;
          default:
            break;
        }
      }
      images.sort(function (a, b) { return a.order - b.order });

      return images.filter(el => el.src != undefined).map(el => el.src);
    }


    opacity = 1;
    startHideCanvasAnim() {
      if (this.requestAnimationFrameID) {
        window.cancelAnimationFrame(this.requestAnimationFrameID)
      }
      this.animationHide()
    }
    startShowCanvasAnim() {
      if (this.requestAnimationFrameID) {
        window.cancelAnimationFrame(this.requestAnimationFrameID)
      }

      // if (this.isLoading == false) {
      //   this.imagesNeedDraw.forEach(img => {
      //     this.context.drawImage(img, 0, 0, this.width, this.height, 0, 0, this.width, this.height);
      //   });
      // }
      this.animationShow()
    }

    requestAnimationFrameID;
    animationShow() {
      // this.opacity += 1000 / 500 / 60;
      if (this.opacity < 1) {
        this.requestAnimationFrameID = window.requestAnimationFrame(this.animationShow.bind(this));
      } else {
        this.opacity = 1;
      }
      this.canvas.style.opacity = this.opacity;

    }
    animationHide() {
      // this.opacity -= 1000 / 500 / 60;//1/60 is time spend of one frame, /2 is 500ms
      if (this.opacity >= 0) {
        this.requestAnimationFrameID = window.requestAnimationFrame(this.animationHide.bind(this));
      } else {
        this.opacity = 0;
      }
      this.canvas.style.opacity = this.opacity;
    }

  }
  customElements.define(
    'product-canvas',
    ProductDisplay
  );

}
